<template>
  <div class="sub-title">{{ $t('space.space_info') }}</div>
  <div class="sub-content"
       :class="{'sub-content-ellipsis' : !isSpaceInfoExpand}"
       ref="refSpaceInfoExpand">
    {{ introductionModelValue }}
  </div>
<!--  <div v-if="isCanSpaceInfoExpand && !isSpaceInfoExpand"
       class="info-more">
            <span class="point"
                  @click="isSpaceInfoExpand = true">
              {{ $t('space.space_show_more') }}
            </span>
  </div>-->
</template>
<script setup
        lang="ts">
import {ref,onMounted} from "vue";

const introductionModelValue = defineModel('introduction', {type: String, default: ''})

const refSpaceInfoExpand = ref(null)
const isCanSpaceInfoExpand = ref(true)
const isSpaceInfoExpand = ref(true)


/*onMounted(() => {
  /// 空間介紹，展開行數判斷
  if (refSpaceInfoExpand.value) {
    isCanSpaceInfoExpand.value = refSpaceInfoExpand.value.scrollHeight > refSpaceInfoExpand.value.offsetHeight
  }
})*/
</script>



<style scoped
       lang="scss">

.sub-content {
  @apply mb-4 text-[18px] text-osn-grey-00 whitespace-pre-line break-all;
  font-family: 'Noto Sans TC', sans-serif;
}
.sub-content-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 4; /* 行数 */
  word-break: break-all;
}
.info-more {
  @apply w-full flex justify-end text-[14px] text-osn-grey-00 underline mt-[-21px];
  span {
    @apply bg-white pl-[10px];
  }
}
</style>
